import { Flex, Button } from 'ui'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useCompanyMembersContext } from '../context/CompanyMembersProvider'

export const Pagination = () => {
  const {
    state: { pageIndex, totalPages, hasNextPage },
    actions: { nextPage: handleNextPage, previousPage: handlePreviousPage },
  } = useCompanyMembersContext()

  const enablePreviousPage = pageIndex > 0
  const enableNextPage = pageIndex < totalPages - 1 || hasNextPage

  return (
    <Flex alignItems="center" gap={3} mt={2} justifyContent="flex-end">
      <Flex alignItems="center" gap={2}>
        <Button
          variant="secondary"
          onClick={handlePreviousPage}
          style={{ padding: 5 }}
          title="Go to first page"
          disabled={!enablePreviousPage}
        >
          <ChevronLeft size={18} />
        </Button>
        <Button
          variant="secondary"
          onClick={handleNextPage}
          style={{ padding: 5 }}
          title="Go to next page"
          disabled={!enableNextPage}
        >
          <ChevronRight size={18} />
        </Button>
      </Flex>
    </Flex>
  )
}
